// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-metric-settings {
  width: 432px;
}
.dialog-metric-settings__row {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.dialog-metric-settings__title {
  width: 106px;
  margin-right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/DialogMetricSettings/DialogMetricSettings.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACR;AAEI;EACI,YAAA;EACA,kBAAA;AAAR","sourcesContent":[".dialog-metric-settings {\n  width: 432px;\n}\n.dialog-metric-settings__row {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n}\n.dialog-metric-settings__title {\n  width: 106px;\n  margin-right: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
